import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    class: ["container-centered", _vm.$whitelabel.WineListCustomerFiltersHidden ? "small" : ""]
  }, [_c("div", {
    attrs: {
      id: "content"
    }
  }, [!_vm.$whitelabel.WineListCustomerFiltersHidden ? _c("div", {
    attrs: {
      id: "wine-filters"
    }
  }, [_vm.isWineList ? _c("AssociateWineFilters", {
    attrs: {
      filters: _vm.searchCriterias.filters,
      filtersVisibility: _vm.filtersVisibility,
      listWineTypes: _vm.availableWineTypes.filter(function (x) {
        return x.name != "Spirit";
      }),
      producers: _vm.listProducers,
      appellations: _vm.listAppellations,
      listCountries: _vm.listWineCountries,
      listRegions: _vm.listWineRegions,
      storageLocations: _vm.storageLocations,
      hasAnySpecialDeal: _vm.hasAnySpecialDeal,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      filtersChanged: _vm.filtersChanged
    }
  }) : _vm._e(), _vm.isSpiritList ? _c("SpiritsFilters", {
    attrs: {
      filters: _vm.searchCriterias.filters,
      producers: _vm.listProducers,
      appellations: _vm.listAppellations,
      listCountries: _vm.listSpiritCountries,
      listRegions: _vm.listSpiritRegions,
      storageLocations: _vm.storageLocations,
      hasAnySpecialDeal: _vm.hasAnySpecialDeal,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      filtersChanged: _vm.filtersChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-list-global-container"
    }
  }, [_vm.thirdPartyOrder || _vm.canManageWines || _vm.canExportPriceList ? _c("div", {
    staticClass: "actions-top-container"
  }, [_vm.thirdPartyOrder ? _c("div", {
    staticClass: "third-party-selector-container"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.thirdPartyUserSelector.display,
      expression: "thirdPartyUserSelector.display"
    }],
    staticClass: "third-party-label"
  }, [_vm._v(" Selected user ")]), _c("div", [_c("AssociateWineThirdPartySelector", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.thirdPartyUserSelector.display,
      expression: "thirdPartyUserSelector.display"
    }],
    attrs: {
      loggedUserData: _vm.loggedUserData,
      userTargetId: _vm.userTargetId,
      disabled: true
    },
    on: {
      refetchWines: _vm.updateThirdPartyUser
    }
  })], 1)]) : _vm._e()]) : _vm._e(), !_vm.$whitelabel.WineListCustomerSearchAndPaginationHidden ? _c("div", {
    attrs: {
      id: "search-criterias"
    }
  }, [_c("div", {
    staticClass: "search-criteria"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      clearable: "",
      placeholder: "Search for a label, ".concat(_vm.isSpiritList ? "spirit, distillery" : "wine, winery", " ..."),
      "append-icon": "fa-search",
      loading: _vm.loadingSearch,
      "hide-details": "auto"
    },
    on: {
      blur: function blur($event) {
        !!_vm.searchCriterias.searchLabel && _vm.advancedSearch();
      },
      "click:append": function clickAppend($event) {
        return _vm.advancedSearch();
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.advancedSearch();
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.searchLabel = null;
        _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.searchLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "searchLabel", $$v);
      },
      expression: "searchCriterias.searchLabel"
    }
  })], 1), !_vm.isMobile() ? _c("div", {
    staticClass: "pagination-right"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      items: _vm.pagingLimitsChoices,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1) : _vm._e()]) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-list-wrapper"
    }
  }, [!_vm.baseModel.wines || _vm.baseModel.wines.length === 0 && !_vm.loadingSearch ? _c("div", {
    staticClass: "list-empty"
  }, [_vm._v(" " + _vm._s(_vm.isSpiritList ? "No spirit available." : "No wine available.") + " ")]) : [_vm.loadingSearch ? _c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  }) : _c("div", {
    staticClass: "wine-list"
  }, _vm._l(_vm.baseModel.wines, function (wine) {
    return _c("div", {
      key: "".concat(wine.id_wine, "_").concat(_vm.currency, "_").concat(wine.customerPriceEuro)
    }, [_c("AssociateWineCard", {
      attrs: {
        wineProp: wine,
        isAddingToCart: _vm.isAddingToCart,
        loggedUserData: _vm.loggedUserData,
        currency: _vm.currency,
        wineCard: _vm.wineCard
      },
      on: {
        associateWine: _vm.associateWine,
        associateCloneWine: _vm.associateCloneWine
      }
    })], 1);
  }), 0)]], 2), !_vm.loadingSearch && !_vm.$whitelabel.WineListCustomerSearchAndPaginationHidden && _vm.baseModel.numberOfPages >= 2 ? _c("div", {
    staticClass: "pagination-bottom"
  }, [_c("div", [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "pagination-right"
  }, [!_vm.isMobile() ? _c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  }) : _vm._e()], 1)]) : _vm._e()])])]), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.casingIdSelected,
      add: _vm.addItemToCart,
      isBasket: true
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };